import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '../../shared/services';

@Component({
  selector: 'app-thankyou-testimonials',
  templateUrl: './thankyou-testimonials.component.html',
  styleUrls: ['./thankyou-testimonials.component.scss']
})
export class ThankyouTestimonialsComponent implements OnInit {
  @Input() config;

  testimonials = [
    {
      content: `My experience on Ketto has been great. I know my contributions are going to children who are in desperate need and I feel like I am making a difference.`,
      name: 'Disha',
      image: '/assets/images/sip/testimonials/disha.png'
    },
    {
      content: `I give Rs 1000 every month to help needy children get life-saving treatments. When I hear their recovery stories, it fills my heart with utmost joy!`,
      name: 'Nitya',
      image: '/assets/images/sip/testimonials/nitya.png'
    },
    {
      content: `I might not be able to save someone alone, but together, there’s so much hope. There’s no better feeling than being a part of someone’s recovery journey.`,
      name: 'Suraj',
      image: '/assets/images/sip/testimonials/suraj.png'
    }
  ];

  breakpoints = {
    767: {
      autoplay: 4000,
      animationDuration: 1500,
      perView: 1,
      startAt: 1,
      focusAt: 'center'
    }
  };

  breakpointsV2 = {
    700: {
      perView: 2.2,
    },
    600: {
      perView: 1.4,
    },
    500: {
      perView: 1.2,
    }
  };

  selectedDonor;
  selectedIndex;

  constructor(
    public utilService: UtilService
  ) { }

  ngOnInit() {
    this.selectedIndex = this.utilService.isMobile() ? 0 : 1;
    this.selectedDonor = this.testimonials[this.selectedIndex];
  }

  selectDonor(donor) {
    if (!this.utilService.isMobile()) {
      this.selectedDonor = donor;
    }
  }

  swiped(e) {
    if (e.direction === '>') {
      this.selectedIndex++;
    } else if (e.direction === '<') {
      this.selectedIndex--;
    }

    if (this.selectedIndex >= this.testimonials.length) {
      this.selectedIndex = 0;
    } else if (this.selectedIndex < 0) {
      this.selectedIndex = this.testimonials.length - 1;
    }

    this.selectedDonor = this.testimonials[this.selectedIndex];
  }

}
